import { IAction } from "src/store";

export const createActionWithPayload = <T extends symbol | string, P>(type: T) => (payload?: P): IAction<T, P> => ({
  type,
  payload,
});
